import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";

const CssTextField = styled(TextField)(({ theme }) => ({
    "& label": {
        color: theme.palette.V080,
    },
    "& label.Mui-focused": {
        color: theme.palette.V080,
    },
    "& label.Mui-error": {
        color: theme.palette.secondary.main, // Color de la etiqueta cuando hay un error
    },
    "& .MuiOutlinedInput-input": {
        fontSize: { xs: "12px !important", lg: 14 },
    },
    "& .MuiOutlinedInput-root": {
        fontSize: { xs: "12px !important", lg: 14 },
        "& fieldset": {
            borderColor: theme.palette.V050, // Color del borde
        },
        "&:hover fieldset": {
            borderColor: theme.palette.V090, // Color del borde en hover
        },
        "&.Mui-focused fieldset": {
            borderColor: theme.palette.V090, // Color del borde en focus
        },
        "&.Mui-error fieldset": {
            borderColor: theme.palette.secondary.main, // Color del borde cuando hay un error
        },
    },
}));

export default function BaseTextField(props) {
    const {
        id,
        name,
        label,
        type,
        InputProps,
        value,
        onChange,
        error,
        onBlur,
        helperText,
        onKeyDown,
        shrink,
        size,
        variant,
        fullWidth,
        required,
        disabled,
        ...rest // Captura cualquier otro parámetro adicional
    } = props;

    return (
        <CssTextField
            {...rest} // Pasa el resto de las props no específicamente mapeadas
            id={id}
            name={name}
            label={label}
            size={size}
            type={type}
            fullWidth={fullWidth}
            value={value}
            onChange={onChange}
            error={error}
            onBlur={onBlur}
            helperText={helperText}
            onKeyDown={onKeyDown}
            variant={variant}
            required={required}
            disabled={disabled}
        />
    );
}
